(function () {
  // ── PRODUCT PAGE BADGE ──────────────────────────────
  const meta = window.__productMeta;
  if (meta && meta.badgeShow) {
    const text  = meta.badgeText  || 'Sale';
    const color = meta.badgeColor || '#e53e3e';

    const wrapper = document.querySelector('.product-badge-wrapper');
    if (wrapper) {
      const badge = document.createElement('span');
      badge.className = 'custom-product-badge';
      badge.textContent = text;
      badge.style.setProperty('--badge-color', color);
      wrapper.appendChild(badge);
    }
  }

  // ── SLIDER / CARD BADGES ────────────────────────────
  document.querySelectorAll('[data-badge-text]').forEach(function (anchor) {
    const text  = anchor.getAttribute('data-badge-text');
    const color = anchor.getAttribute('data-badge-color') || '#e53e3e';
    const show  = anchor.getAttribute('data-badge-show');

    if (show !== 'true' || !text) return;

    const badge = document.createElement('span');
    badge.className = 'custom-product-badge';
    badge.textContent = text;
    badge.style.setProperty('--badge-color', color);
    anchor.appendChild(badge);
  });
})();